import { render, staticRenderFns } from "./ProfileSetting.vue?vue&type=template&id=7279a26e&"
import script from "./ProfileSetting.vue?vue&type=script&lang=ts&"
export * from "./ProfileSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports